import React from 'react'
import NavbarContainer from '../Components/Navbar/Navbar'
import HomeSection from '../Components/HomeSection'
import Aboutus from '../Components/Aboutus/Aboutus'
import Growth from "../Components/Growth/Index";
import Partners from "../Components/Partners/Index";
import Service from "../Components/Services/Index";
import Contactus from "../Components/Contactus/Contactus";
import Footer from "../Components/Footer/Footer";

function Home() {
  return (
    <>
<NavbarContainer/>
<HomeSection/>
      <Aboutus />
            <Service />
      {/* <Growth/> */}
      <Partners/>
              <Contactus />

<Footer/>
    </>
  )
}

export default Home
